/* eslint-disable react/no-this-in-sfc */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { LectionSlideDto } from '../../dto/LectionImageDto';
import { getHeightMegduSlov, getTable, selectTheme } from '../../utils/utils';
import { TableDto } from '../../dto/TableDto';
import { TABLE_VIEW_CHANGE_WIDTH_WINDOW } from '../../constant/constants';

interface Props {
  scaleNew: number;
  curTheme: number;
  realSystemTheme: number;
  fontSize: string;
  dto: LectionSlideDto;
}

export const LectionDivTableItem: FunctionComponent<Props> = ({
  scaleNew,
  curTheme,
  realSystemTheme,
  fontSize,
  dto,
}) => {
  const [tableDto, setTableDto] = useState<TableDto>(
    getTable(dto.tableContent)
  );

  const [scale, setScale] = useState(scaleNew);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: selectTheme(
        dto.backgroundText,
        curTheme,
        realSystemTheme
      ),
      fontSize,
      color: selectTheme(dto.textColor, curTheme, realSystemTheme),
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize,
      color: selectTheme(dto.textColor, curTheme, realSystemTheme),
    },
    padding: 'none',
    borderWidth: 1,
    borderColor: selectTheme('#bdbdbd;#424242', curTheme, realSystemTheme),
    borderStyle: 'solid',
  }));

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
      backgroundColor: selectTheme(
        dto.backgroundText,
        curTheme,
        realSystemTheme
      ),
    },
    '&:nth-of-type(odd)': {
      backgroundColor: selectTheme(
        dto.backgroundImage,
        curTheme,
        realSystemTheme
      ),
    },
    padding: 'none',
  }));

  useEffect(() => {
    setScale(scaleNew);
  }, [scaleNew]);

  useEffect(() => {
    setTableDto(getTable(dto.tableContent));
  }, [dto]);

  return (
    <div
      style={{
        background: selectTheme(dto.backgroundText, curTheme, realSystemTheme),
      }}
    >
      <Typography
        style={{
          marginTop: '20px',
          fontFamily: 'sans-serif',
          fontSize,
          overflow: 'auto',
          fontWeight: '400',
          textAlign: 'left',
          color: selectTheme(dto.textColor, curTheme, realSystemTheme),
          lineHeight: getHeightMegduSlov(fontSize),
        }}
        component="html"
      >
        <div dangerouslySetInnerHTML={{ __html: dto.text }} />
      </Typography>
      <TableContainer
        style={{
          background: selectTheme(
            dto.backgroundText,
            curTheme,
            realSystemTheme
          ),
        }}
      >
        <Table
          style={{
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
            width: '100%',
          }}
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow>
              {tableDto.headers.map((column) => (
                <StyledTableCell
                  sx={{ fontWeight: '700' }}
                  key={column}
                  align="center"
                >
                  {column}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableDto.rows.map((rowsa) => (
              <StyledTableRow sx={{ whiteSpace: 'pre-line' }}>
                {rowsa.map((item) => {
                  const value =
                    item !== 'пусто' ? item.replaceAll('new-line', '\n') : '';
                  return (
                    <StyledTableCell sx={{ padding: '5px' }} align="left">
                      {value}
                    </StyledTableCell>
                  );
                })}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
